import { createContext, useContext } from 'react';

import { ProvisionNodesDrawerContextValue } from './types';

export const ProvisionNodesDrawerContext =
  createContext<ProvisionNodesDrawerContextValue>({
    clusterId: undefined,
    edgeLocation: undefined,
    hasEdgeLocationPredefined: false,
    setEdgeLocation: () => {},
    customConfigValue: undefined,
    cloudConfigValue: undefined,
    setCustomConfigValue: () => {},
    setCloudConfigValue: () => {},
  });

export const useProvisionNodesDrawerContext = () =>
  useContext(ProvisionNodesDrawerContext);
